import React, { useState } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableWrapper,
  TableAction,
  ModalDeleteConfirm,
  TableCellDefault,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useFetch, useDatatables } from "App/hooks";
import {
  ModalForm,
  headCells,
  deleteSpesialistById,
  RESET_STATE_SPESIALIS,
} from "./helpers";
import { TYPE_INSTANCE1 } from "App/constants";
import { FilterColumns, PrepareDataExport } from "../helpers";
import { LIST_URL_MASTER } from "utils/masters";
import { scrollToTop } from "App/utils/helpers";

export default function Spesialis() {
  const classes = STYLE_DEFAULT_MASTER();

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [rows, setRows] = useFetch(
    TYPE_INSTANCE1,
    LIST_URL_MASTER.spesialis.list
  );

  const [formData, setFormData] = useState(RESET_STATE_SPESIALIS);

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      code: row?.code,
      codebridgepolibpjs: row?.codebridgepolibpjs,
      codebridgesubspesialist: row?.codebridgesubspesialist,
    });
    scrollToTop();
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  return (
    <div
      className={classes.root}
      style={{
        marginTop: "2rem",
      }}
    >
      <ModalForm
        setRows={setRows}
        formData={formData}
        setFormData={setFormData}
      />

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteSpesialistById(
              formData.id,
              setRows,
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableSpesialis
        clickDelete={clickDelete}
        clickUpdate={clickUpdate}
        rows={rows}
      />
    </div>
  );
}

const TableSpesialis = ({ clickUpdate, clickDelete, rows }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name", "code"],
  });

  const prepareHeaders = {
    code: "kode",
    name: "nama",
    createdAt: "inserted_time:date",
    createdName: "inserted_by",
    updatedAt: "updated_time:date",
    updatedName: "updated_by",
  };
  const dataExport = PrepareDataExport(data, prepareHeaders);
  const headerExport = FilterColumns(dataExport);

  return (
    <div className="mt-1">
      <TableWrapper
        title="Daftar Spesialis"
        setQ={setQ}
        withAddButton={false}
        withExportButton={true}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        allData={dataExport}
        headers={headerExport}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  width={"5%"}
                  align="center"
                >
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>
                <TableCell align="left">{row?.code}</TableCell>
                <TableCell align="left">{row?.codebridgepolibpjs}</TableCell>
                <TableCell align="left">{row?.name}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
};
